import { startTransition } from "react";

const CategoryChipBar = ({ chips, activeChip, onSelect }) => {
  const handleClick = (key) => {
    // Mark as non-urgent — keeps UI responsive while shelves swap
    startTransition(() => onSelect(key));
  };

  return (
    <div
      className="flex items-center gap-2 overflow-x-auto scrollbar-hide py-2"
      style={{ scrollbarWidth: "none" }}
    >
      {chips.map((chip) => {
        const isActive = activeChip === chip.key;
        return (
          <button
            key={chip.key}
            onClick={() => handleClick(chip.key)}
            className={`shrink-0 inline-flex items-center gap-1.5 px-4 py-2 rounded-full text-sm font-semibold transition-all whitespace-nowrap border ${
              isActive
                ? "bg-primary text-white border-primary"
                : "bg-white/5 text-white/70 hover:text-white border-white/10 hover:border-white/20"
            }`}
          >
            {chip.icon && <span className="inline-flex">{chip.icon}</span>}
            {chip.label}
          </button>
        );
      })}
    </div>
  );
};

export default CategoryChipBar;
